//3rd party Imports
import { Link } from "react-router-dom";
import { Col } from "antd";
import React from "react";

//Local imports
import Pills from "modules/Common/Components/Pills";
import TemplateSearch from "./TemplateSearch";
import { TEMPLATES_TYPE } from "./constants";

//Style imports
import styled from "styled-components";

type TemplatesHeaderProps = {
  templateType: string;
  searchValue: string;
  setTemplateType: (value: string) => void;
  searchTemplates: (value: any) => void;
  cleanSearchField: () => void;
  clearAllSelection: () => void;
};

const TemplatesHeader: React.FC<TemplatesHeaderProps> = (props: TemplatesHeaderProps) => {
  const { setTemplateType, templateType, searchValue, searchTemplates, cleanSearchField, clearAllSelection } =
    props;

  const handleTabSwitching = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, type: string) => {
    // Render respective templates according to tabs
    e.preventDefault();
    setTemplateType(type);
    clearAllSelection();
  };

  return (
    <React.Fragment>
      <Col className="gutter-row pb-2" span={12}>
        <TemplateSearch
          cleanSearchField={cleanSearchField}
          searchTemplates={searchTemplates}
          value={searchValue}
        />
      </Col>
      <Col className="gutter-row" span={24}>
        <TabsWrapper className="d-flex padding-bottom-lg">
          <ul>
            <li>
              <Link to={"#"} onClick={(e) => handleTabSwitching(e, TEMPLATES_TYPE.FEATURED)}>
                <Pills title="xiQ Featured" active={templateType === TEMPLATES_TYPE.FEATURED && "true"} />
              </Link>
            </li>
            <li>
              <Link to={"#"} onClick={(e) => handleTabSwitching(e, TEMPLATES_TYPE.MY_TEMPLATES)}>
                <Pills title="My Templates" active={templateType === TEMPLATES_TYPE.MY_TEMPLATES && "true"} />
              </Link>
            </li>
            <li>
              <Link to={"#"} onClick={(e) => handleTabSwitching(e, TEMPLATES_TYPE.SHARED)}>
                <Pills title="Shared with me" active={templateType === TEMPLATES_TYPE.SHARED && "true"} />
              </Link>
            </li>
          </ul>
        </TabsWrapper>
      </Col>
    </React.Fragment>
  );
};

export default TemplatesHeader;

const TabsWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  margin-left: -5px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding-bottom: 12px !important;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    li {
      margin: 5px 5px;
      button {
        padding: 0 !important;
      }
    }
  }
  p.articles-count {
    margin-bottom: 0px;
    color: rgb(126, 126, 126);
    font-size: 14px;
    font-weight: 600;
    font-family: "robotomedium";
    white-space: nowrap;
    display: inline-block;
    float: right;
  }
`;
